import { render, staticRenderFns } from "./WidgetCommonProps.vue?vue&type=template&id=98bb4dc6"
import script from "./WidgetCommonProps.vue?vue&type=script&lang=js"
export * from "./WidgetCommonProps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports